import WhiteStarIcon from "@Icons/WhiteStarIcon";
import classes from "./ReviewCaptionStyles.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import { ANONYMOUS_REVIEWER_KEY } from "../../ReviewsSectionV2/anonymousReviewer";

const ReviewCaption = ({ userName, rating, anonymous }: any) => {
  const { t } = useTranslationHook();
  return (
    <div className={classes.captionComponentSection}>
      <div className={classes.name}>{anonymous ? t(ANONYMOUS_REVIEWER_KEY) : userName}</div>
      <div className={classes.rating}>
        {rating}
        <WhiteStarIcon />
      </div>
    </div>
  );
};

export default wrapperHOC(ReviewCaption, {
  componentName: "ReviewCaption-ReviewsSection-PropertyPage",
  showForChina: true,
});
